import { ApiClient } from "@/services/ApiService";
import mime from "mime-types";

export default {
  async deleteTestDocument(id) {
    const response = await ApiClient.delete(`testdocument/${id}`);
    return response.data;
  },
  async getTestDocuments() {
    const response = await ApiClient.get(`testdocument`);
    return response.data;
  },
  async getTestDocument(id) {
    const response = await ApiClient.get(`testdocument/${id}`);
    return response.data;
  },
  async getFile(id) {
    const response = await ApiClient.get(`testdocument/downloadfile/${id}`, {
      responseType: "blob"
    });

    const file = {
      data: response.data,
      extension: mime.extension(response.data.type),
      name: response.data.name
    };

    return file;
  },
  async getTestDocumentsByTestId(id) {
    const response = await ApiClient.get(`testdocument/bytest/${id}`);
    return response.data;
  },
  async postTestDocument(testdocument, testId) {
    const response = await ApiClient.post(
      `testdocument/uploadfile/${testId}`,
      testdocument
    );
    return response.data;
  },
  async putTestDocument(testdocument) {
    const response = await ApiClient.put(
      `testdocument/${testdocument.testdocumentId}`,
      testdocument
    );
    return response.data;
  }
};
